const flame = {
  blue: "Blue",
  yellow: "Yellow",
  orange: "Orange",
  red: "Red",
  focused: "Focused",
  semiFocused: "Semi Focused",
  highDispersion: "High Dispersion"
};

export default flame;
